/*
 * The catalogue's half of the toast region — the recruiter app's `app/toasts.tsx` has the argument
 * for why this four-line component exists at all.
 *
 * Duplicated rather than shared, and deliberately: the two apps have no common package to put it in
 * that is not the design system, and the design system is the one place it cannot go.
 */

import { ToastProvider } from '@indovation/design-system';
import { useI18n } from '@indovation/i18n/react';
import type { ReactNode } from 'react';

export function Toasts({ children }: { children: ReactNode }) {
  const { t } = useI18n();

  return (
    <ToastProvider labels={{ region: t('toast.region'), dismiss: t('toast.dismiss') }}>
      {children}
    </ToastProvider>
  );
}
